import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

class BrixThreeColumnGrid {
  static init(...parameters) {
    return new BrixThreeColumnGrid(...parameters);
  }

  constructor(block) {
    this.block = block;
    gsap.registerPlugin(ScrollTrigger);

    const mm = gsap.matchMedia();

    mm.add(
      {
        isMobile: '(max-width: 576px)',
      }, (context) => {
        const { isMobile } = context.conditions;

        if (isMobile) {
          const background = this.block.querySelector('.background');
          const content = this.block.querySelector('.content');
          const { paddingTop, paddingBottom } = window.getComputedStyle(this.block);
          gsap.timeline({
            scrollTrigger: {
              trigger: content,
              pin: background,
              pinSpacing: false,
              start: `top-=${paddingTop} top`,
              end: `bottom+=${paddingBottom} bottom`,
            },
          });
        }
      },
      this.block,
    );
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-three-column-grid', BrixThreeColumnGrid.init);
}
